import { Logo } from '../../components/Logo';

export function Splash({ text = 'Das Feuer wird entfacht …' }: { text?: string }) {
  return (
    <div className="splash" data-testid="splash" role="status" aria-live="polite">
      <div className="splash-flame">
        <Logo size={72} />
      </div>
      <p className="muted">{text}</p>
    </div>
  );
}
